import { displayError, displayWarning } from "../../utils/messageToast";
import { SetupNotAuth } from "../../apis/apiNotAuthenticate";
import { AllForms } from "../../utils/functionsInterfaces";

export const getFormByIdItemIdPayload = async (
  clientId: string,
  search: string,
  ambient: string,
  setNameForm: React.Dispatch<React.SetStateAction<string>>,
  setTabIdForm: React.Dispatch<React.SetStateAction<string>>,
  setSkillIdForm: React.Dispatch<React.SetStateAction<string>>,
  setIdForm: React.Dispatch<React.SetStateAction<string>>,
  setAllForm: React.Dispatch<React.SetStateAction<AllForms[]>>,
  signOut: () => void
) => {
  try {
    const apiClient = SetupNotAuth();
    const response = await apiClient.post(`/get-form`, {
      clientId,
      alias: search,
      ambient,
    });

    const form = response.data.form;

    setAllForm([form]);
    setIdForm(form.id || "");
    setNameForm(form.name || "");
    setSkillIdForm(form.skillId || "");
    setTabIdForm(form.tabId || "");
  } catch (error: any) {
    if (error.response.status === 404) {
      displayWarning("Formulário não encontrado!");
    } else if (error.response.status === 401) {
      displayWarning("Você não tem permissão para acessar este formulário!");
    } else {
      displayError("Erro ao buscar formulário!");
    }
  }
};
